import $ from 'jquery';

$(function () {

	/** Pipeline dropdown functionality */

	/**
	 * Open pipeline filter group dropdown.
	 */

	$(".pipeline-field__tab").on('click', function () {
    $(".pipeline-field__tab").not(this).removeClass('active').next().slideUp(250);
    $(this).toggleClass('active').next().slideToggle(250);
	});

	/**
	 * Allow entire element to be clicked, not just
	 * the checkbox label.
	 */
	$(".form-pipeline .pipeline-field__option:not(.pipeline-field__option--filter)").on('click', function () {
		var checked = $(this).find('.pipeline-field__checkbox').prop('checked');
        if (!checked) {
         $(this).find('.pipeline-field__checkbox').prop('checked', true);
        } else {
         $(this).find('.pipeline-field__checkbox').prop('checked', false);
        }
		$(this).find('.pipeline-field__checkbox').trigger('change');
	});

	/**
	 * Filter selected.
	 */
	$(".form-pipeline .pipeline-field").on('change', '.pipeline-field__checkbox', function () {

		// Add active state
		if ($(this).prop("checked")) {
			$(this).parent().toggleClass('active');
		} else {
			$(this).parent('.pipeline-field__option').removeClass('active');
		}

		// Update filter count
		let count = $(this).parent().parent().find(".pipeline-field__option.active").length;
		$(this).parents('.pipeline-field').find(".pipeline-field__tab .total").html('(' + count + ')');

	});

	/**
	 * Update pipeline filter results (used on the results page)
	 */
	$('.form-pipeline--results').on('submit', function (e) {
		e.preventDefault();
		var formData = $(this).serialize();

		$(".pipeline-field__tab.active").next().slideUp(250);
		$(".pipeline-field__tab").removeClass('active');

		$.ajax({
			type: $(this).attr('method'),
			url: $(this).attr('action'),
			data: formData,
			action: 'pipeline_filter_results',
			success: function (data) {

				// console.log(data);

				if (typeof data !== 'string') {
					$('.js-limit-modal').addClass('active');
				} else {
					$('#pipelineResultsContainer').html(data);
					let totalResults = $('input[name="total_results"]').val()
					let number = parseInt(totalResults).toLocaleString("en-US");
					$('.totalProjects').text(number);
					$(".pipeline-field__tab.active").next().slideUp(250);
					$('.js-pipeline-total-leads').text(`${totalResults} leads?`)
				}

				// TODO: Check if limit has been reached, if so show modal

			},
			error: function (xhr, status, error) {
				// This line may need updating to handle errors better I just put it in so it didnt do the alert
				$('#pipelineResultsContainer').html('<div class="bg-gradient-green-vertical py-8 my-8 xl:bg-gradient-green-tilt-130 w-full 2xl:w-3/4 mx-auto text-center rounded-lg"><h2 class="title-display mb-4 title-display--xl text-white">You have reached your trial limit! <br> want to access all leads?</span></h2><button class="btn btn-md btn-blue"><span><svg xmlns="http://www.w3.org/2000/svg" class="arrow arrow-tilt" width="19.454" height="17.399"><g fill="none" stroke="#fff" stroke-miterlimit="10" stroke-width="2"><path d="m9.955 2.315 6.386 6.386-6.386 6.385" /><path d="M16.34 8.7H1.514" /></g></svg>Book your demo</span></button></div>')
			}
		})

	})

	/**
	 * Update filter count (not used on results page)
	 */
	$(".form-pipeline:not(.form-pipeline--results) .pipeline-filter").on('click', function (e) {
			e.preventDefault();

			// Get all selected filters
			const $form = $(this).parents('.form-pipeline');

			// Update filter count
			updatePipelineFilterCount($form);

			// Update URL to contain filters
			const url = new URL(window.location.href);

      // Loop through the possible filter options and remove any that are already in the URL
      const filterOptions = [
        "values",
        "locations",
        "sectors",
        "planningstages",
        "contractstages",
      ];
      filterOptions.map((option) => {
        const filtersToRemove = [];

        // URL keys will be returned as key[1], key[2]. So you cannot search for key[].
        for (const [key, value] of url.searchParams.entries()) {
          if (key.includes(option)) {
            filtersToRemove.push([key, value]);
          }
        }
        filtersToRemove.map(([key, value]) => {
          url.searchParams.delete(key);
        });
      });

      // Append new search parameters from the form
      $form.serializeArray().forEach(function (item) {
        url.searchParams.append(item.name, item.value);
      });

      // Update the browser history with the new URL
      window.history.pushState({}, "", url);

			$(".pipeline-field__tab.active").next().slideUp(250);
			$(".pipeline-field__tab").removeClass('active');

			// Show opportunities
			$('.form-pipeline__opportunities').show();

	});

	function updatePipelineFilterCount($form) {

		// Make request to get updated count
		$.ajax({
			url: '/wp-admin/admin-ajax.php?action=gln_pipeline_filter_count',
			method: 'GET',
			data: $form.serialize(),
			success: function (data) {

				var finalTotalProjectCount = data.totalProjectCount;
				var formattedTotalProjectCount = finalTotalProjectCount.toLocaleString();
				var $totalLeadsElement;
				var $findingLeadsElement = $form.find('.js-pipeline-finding-leads');

				if ($form.hasClass('form-pipeline--navigation')) {
        	$totalLeadsElement = $form.parent().find('.js-pipeline-total-leads');
				} else {
					$totalLeadsElement = $form.find('.js-pipeline-total-leads');
				}

				$totalLeadsElement.text('0');
				$findingLeadsElement.text('Finding sales leads:')

				// Animate the element from 0 to the final total
				$({ counter: 0 }).animate({
        	counter: finalTotalProjectCount
    		}, {
						duration: 2000, // Adjust the duration as needed
						easing: 'swing',
						step: function() {
								$totalLeadsElement.text(Math.ceil(this.counter).toLocaleString());
						},
						complete: function() {
								$totalLeadsElement.text(formattedTotalProjectCount);
								$findingLeadsElement.text('Number of opportunities:')
						}
				});
			}
		});

	}

	/**
	 * Update filter count on page load, checks if the
	 * URL params contain any filters before triggering.
	 */
	function checkAppliedfilters() {

		const url = new URL(window.location.href);
		let hasfilters = false;

		for (const [key] of url.searchParams.entries()) {
			const filter = key.split('[')[0];
			if (['locations', 'sectors', 'planningstages', 'contractstages', 'values'].includes(filter)) {
				hasfilters = true;
				break;
			}
		}

		if (hasfilters) {
			const $header = $('.form-pipeline--navigation');
			updatePipelineFilterCount($header);
			const $main = $('.form-pipeline--main');
			updatePipelineFilterCount($main);
		}

	}

	// Run on page load
	checkAppliedfilters();

});